import $ from "jquery";

const uncertaintyItem = $('.js-uncertainty-item');

uncertaintyItem.on('mouseenter', function() {
    uncertaintyItem.removeClass('is-active');
    $(this).addClass('is-active');
});